// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"ed71cdd9","470":"bb3c5581","556":"bb3c5581","865":"bb3c5581","897":"bb3c5581","899":"bb3c5581"}[chunkId] + ".chunk.css";
};